/*
 * <clicklease-estimate data-amount="1234.56" hidden>
 * Fetches ClickLease's estimated monthly lease payment for data-amount (dollars)
 * and fills the [data-clicklease-amount] node, then un-hides the element. Any
 * failure (network, non-200, no numeric "object" in the JSON) leaves it hidden.
 * Rendered by snippets/pdp-clicklease.liquid, which only outputs the element for
 * prices inside ClickLease's range. Estimates are cached per amount for the page.
 */
if (!customElements.get('clicklease-estimate')) {
  const estimateCache = new Map();

  const fetchEstimate = (amount) => {
    if (!estimateCache.has(amount)) {
      const request = fetch(`https://app.clicklease.com/api/estimatedPaymentAmount/${encodeURIComponent(amount)}`)
        .then((response) => {
          if (!response.ok) throw new Error(`ClickLease ${response.status}`);
          return response.json();
        })
        .then((json) => {
          const monthly = Number(json && json.object);
          if (!Number.isFinite(monthly) || monthly <= 0) throw new Error('ClickLease: no estimate');
          return monthly;
        });
      // Do not cache failures, so a later variant switch can retry.
      request.catch(() => estimateCache.delete(amount));
      estimateCache.set(amount, request);
    }
    return estimateCache.get(amount);
  };

  customElements.define(
    'clicklease-estimate',
    class ClickLeaseEstimate extends HTMLElement {
      connectedCallback() {
        const amount = parseFloat(this.dataset.amount);
        const target = this.querySelector('[data-clicklease-amount]');
        if (!target || !Number.isFinite(amount)) return;

        fetchEstimate(amount)
          .then((monthly) => {
            if (!this.isConnected) return;
            target.textContent = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 0,
            }).format(monthly);
            this.hidden = false;
          })
          .catch(() => {
            this.hidden = true;
          });
      }
    },
  );
}
